import { splitStringBySubstring as e } from "./helpers/splitStringBySubstring.js";
import t from "./HighlightSearch.module.js";
import { c as n } from "react/compiler-runtime";
import r from "react";
import { jsx as i } from "react/jsx-runtime";
var a = r.memo((r) => {
	let a = n(31), c, l, u, d;
	a[0] === r ? (c = a[1], l = a[2], u = a[3], d = a[4]) : ({search: u, line: c, className: d, ...l} = r, a[0] = r, a[1] = c, a[2] = l, a[3] = u, a[4] = d);
	let f = d === void 0 ? "" : d;
	if (typeof u != "string" || typeof c != "string" || u === "") {
		let e;
		return a[5] !== f || a[6] !== c || a[7] !== l ? (e = /* @__PURE__ */ i("span", {
			...l,
			className: f,
			children: c
		}), a[5] = f, a[6] = c, a[7] = l, a[8] = e) : e = a[8], e;
	}
	let p = u.split(",").map(o).filter(Boolean), m = c.toLowerCase();
	if (p.length > 1 && p.every((e) => m.includes(e))) {
		let e;
		a[9] === c ? e = a[10] : (e = /* @__PURE__ */ i("mark", {
			className: t.mark,
			"data-test": "HighlightSearch_mark",
			children: c
		}), a[9] = c, a[10] = e);
		let n;
		return a[11] !== f || a[12] !== l || a[13] !== e ? (n = /* @__PURE__ */ i("span", {
			...l,
			className: f,
			children: e
		}), a[11] = f, a[12] = l, a[13] = e, a[14] = n) : n = a[14], n;
	}
	let h, g, _, v;
	if (a[15] !== f || a[16] !== c || a[17] !== l || a[18] !== u) {
		v = Symbol.for("react.early_return_sentinel");
		bb0: {
			let t = e(c, u);
			if (t.length === 1) {
				let e;
				a[23] !== f || a[24] !== c || a[25] !== l ? (e = /* @__PURE__ */ i("span", {
					...l,
					className: f,
					children: c
				}), a[23] = f, a[24] = c, a[25] = l, a[26] = e) : e = a[26], v = e;
				break bb0;
			}
			h = l, g = f, _ = t.map(s);
		}
		a[15] = f, a[16] = c, a[17] = l, a[18] = u, a[19] = h, a[20] = g, a[21] = _, a[22] = v;
	} else h = a[19], g = a[20], _ = a[21], v = a[22];
	if (v !== Symbol.for("react.early_return_sentinel")) return v;
	let y;
	return a[27] !== h || a[28] !== g || a[29] !== _ ? (y = /* @__PURE__ */ i("span", {
		...h,
		className: g,
		children: _
	}), a[27] = h, a[28] = g, a[29] = _, a[30] = y) : y = a[30], y;
});
function o(e) {
	return e.trim().toLowerCase();
}
function s(e, n) {
	return n % 2 == 0 ? e === "" ? null : /* @__PURE__ */ i(r.Fragment, { children: e }, `${n}-${e}`) : /* @__PURE__ */ i("mark", {
		className: t.mark,
		"data-test": "HighlightSearch_mark",
		children: e
	}, `${n}-${e}`);
}
//#endregion
export { a as HighlightSearch };
